// Mirror of packages/widget/src/webrtc/metrics.ts. The agent app also fires
// the ICE-failed counter so we get both sides of a failed call.

import type { SessionId } from '@prakash-software/shared';

let serverUrl: string | null = null;

export function configureWebRTCMetrics(url: string): void {
  serverUrl = url.replace(/\/$/, '');
}

export function reportIceFailed(payload: { sessionId: SessionId; role: 'visitor' | 'agent' }): void {
  if (!serverUrl) return;
  try {
    void fetch(`${serverUrl}/api/metrics/ice-failed`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        sessionId: payload.sessionId,
        role: payload.role,
        at: Date.now(),
      }),
      keepalive: true,
    });
  } catch {
    /* swallow */
  }
}
